<div class="multi-chat-navigation d-flex flex-column overflow-hidden h-100">
  <div
    class="d-none d-lg-block px-5 py-8"
  >
    <button
      type="button"
      class="btn app-btn-white btn-outline w-100 py-6 fs-5 color-primblack fw-bold multi-chat-new"
      (click)="createNewTask()"
    >
      Create new task
    </button>
  </div>
  <div class="hide-scrollbar flex-1 h-100">
    <div>
      <app-multi-chat-navigation-card
        #chatNavigationCardComponent
        *ngFor="let ticket of tickets; index as i; trackBy: trackByFn"
        [ticket]="ticket"
        [isTicketChosen]="chosenTicket?.id === ticket.id"
        (click)="chooseTicket(ticket)"
      ></app-multi-chat-navigation-card>
    </div>
    <div class="d-flex justify-content-center position-relative">
      <ngx-spinner [fullScreen]="false"
                   bdColor="#00000000"
                   color="#000000"
                   name="loadMoreTicketsSpinner"
                   size="default"
                   type="ball-running-dots"
      ></ngx-spinner>
    </div>
    <div *ngIf="showMore" class="d-flex justify-content-center more-btn-container my-5 my-md-8">
      <button (click)="loadMoreTickets()" class="btn rounded-pill app-btn-gray btn-outline py-3 px-5">
        Show more
      </button>
    </div>
  </div>
  <app-new-task-message
    class="d-block d-lg-none"
    (newTaskCreated)="createNewTask()"
  ></app-new-task-message>
</div>
